import { schema } from 'normalizr';

export const businessProcessesSchema = [new schema.Entity('businessProcess')];

export const businessProcessesEventsSchema = [new schema.Entity('events')];
